export const years = [
  { label: '5 lat', value: 5 },
  { label: '10 lat', value: 10 },
  { label: '15 lat', value: 15 },
  { label: '20 lat', value: 20 },
  { label: '25 lat', value: 25 },
];
